export const RECENT_FORMS_QUANTITY = 5;
